import { Checkbox } from "@primer/react";

export const adsTableConfig = () => {
    return [
        {
            id: "select",
            field: "",
            sortBy: "basic",
            header: () => <Checkbox value="default" disabled />,
            rowHeader: true,
            maxWidth: 40
        },
        {
            id: "title",
            header: "Наименование",
            field: "title",
            sortBy: "basic",
            rowHeader: true,
        },
        {
            id: "username",
            header: "Имя",
            field: "username",
            sortBy: "basic",
        },
        {
            id: "category",
            header: "Раздел",
            field: "category",
            sortBy: "basic",
        },
        {
            id: "subcategory",
            header: "Подраздел",
            field: "subcategory",
            sortBy: "basic",
        },
        {
            id: "status",
            header: "Статус",
            field: "status",
        },
        {
            id: "price",
            header: "Цена",
            field: "price",
            sortBy: "basic",
        },
        {
            id: "date",
            header: "Дата размещения",
            field: "date",
        },
    ];
}
